fx.ns("desktop.book", class Main extends shared.BookMain {

	constructor() 
	{
		super();

        fx.set("app-device", "app-desktop");
        fx.set("app", "book"); 
        fx.set("app-project", this.is3d ? "3d" : "standard");
	}

	init()
	{
        
		this.views = [  "desktop.common.screens.Splash",
						//"desktop.common.screens.CoverAlbum",
                        "shared.screens.CoverAlbum",
						//"desktop.common.screens.ShapeAlbum",
                        "shared.screens.ShapeAlbum",
						//"desktop.common.screens.SizeAlbum",
                        "shared.screens.SizeAlbum",
						//"desktop.common.screens.HardCover",
                        "shared.screens.HardCover",
						"desktop.common.preview.Preview",
						//"desktop.common.preview.PreviewAI",
						"desktop.book.edition.BookEditor",
						"desktop.common.photoimport.PhotoChoices",
						"desktop.book.edition.PhotoChoicesIA",
						"desktop.book.edition.PhotoAnalyse",
						"desktop.book.edition.PhotoList",
						//"desktop.book.edition.ThemeCategories",
                        "shared.screens.ThemeCategories",
						"desktop.book.edition.ThemeAlbum",
						"desktop.book.edition.CreateAlbum",
						"desktop.book.edition.CreatingAlbum",
						"desktop.book.edition.PhotoListWaiting",
						"desktop.common.screens.Saving",
						"desktop.common.photoimport.AlbumsPhotos", 
						"desktop.common.photoimport.GooglePanel", 
						"desktop.common.photoimport.FacebookPanel", 
						"desktop.common.photoimport.InstagramPanel",
						"desktop.common.photoimport.UploadProgress",
						"desktop.common.screens.SuspendedBook",
						"desktop.common.panels.InfoPanel",
						"desktop.common.panels.SharedPhotosPanel",
						"desktop.common.panels.CheckBookPanel",
						//"desktop.common.panels.ChangeLayoutsPanel",
						//"desktop.common.panels.ChangeThematicsPanel",
						"desktop.common.panels.ChangeThemesPanel",
						"desktop.common.panels.ProposePreviewPanel",
					];

		fx.enableToolTip();

		if (fx.browser.isTablet && !Utils.getURLParam("desktop")) // case for IPAD pro that appear as desktop
			this.navigateToURL(window.location.pathname + "?tablet=true" + (this.previewMode ? "&preview=true" : ""));
	
		this.on("TAB-DOWN", this._toggleGridMode, fx.keyboard);
	}
	

	onDataEvent(e)
	{
		switch(e.type)
		{
			case "start":
				if (this.model.creationid)
                {
                    this.steps({view : "Splash", skipPrevious : true}, this.previewMode ? "CheckBookPanel" : "BookEditor");
                }
                else
                if (this.is3d)
                {
                    fx.set("mode", "creating");
                    let steps = [];

                    // 3D book, by default no choice, 21x21cm soft cover
                    //steps.push("SizeAlbum");
                    //steps.push("CoverAlbum");
                    //steps.push("HardCover");
                    steps.push("Splash");
                    steps.push("BookEditor");

                    this.steps(steps);
                }
                else
				if (this.ia)
				{
                    fx.set("mode", "creating-ia");

					fx.service("AIService").init();
					
					this.steps( {view : "Splash", skipPrevious : true}, 
								"PhotoChoicesIA", 
								{view : "PhotoListWaiting", skipPrevious : true}, 
								{view : "PhotoAnalyse", skipPrevious : true}, 
							 );
				}
				else
				{
                    fx.set("mode", "creating");

                    let steps = [];

                    if (!this.model.themeid)
                    {
                        if (!this.model.choosedThemeTag)
                            steps.push("ThemeCategories");
                    }

                    // TODO : at creation, inject availableShapes, availableSizes and availableCovers
                    // in page, so Main has access to it (like product).
                    
                    /*if (this.availableShapes)

                    if (this.availableSizes)

                    if (this.availableCovers)*/


                    if (!this.model.choosedFormat)
                    {
                        if (!this.model.choosedShape)
                            steps.push("ShapeAlbum");
                        
                        if (!this.model.choosedSize)
                            steps.push("SizeAlbum");
                    }
                    
					if (!this.model.choosedCover)
					{
						steps.push("CoverAlbum");
                        steps.push("HardCover");
					}

                    steps.push("Splash");
                    steps.push("BookEditor");

					this.steps(steps);
				}
				
				break;

			case "creation-created" :
			case "creation-loaded":
				fx.service("PhotoSharingService").start();
				
				//if (this.previewMode)
				//{
				//	if (this.model.report().failed)	// Display warning popup only if there are reports on one/several page(s) or if number of pages is not a multiple of 4
				//	{
                        //this.model.event("checkbook-panel", null, 1500);
						//this.switchTo("BookEditor");
						//this.switchTo("CheckBookPanel");
				//	}
				//	else	
				//	{
                //        this.model.event("navigate-order");
						//this.switchTo("Preview");
						//this.switchTo("ProposePreviewPanel");
						//this.popup(new common.popups.ProposePreview(this.model, true));
				//	}
				//}

				break;
				
			case "step-PhotoAnalyse":
			case "show-editor":
				if(this._lastView == "Preview" && this.currentView == "InfoPanel")
				{
					this.switchTo("Preview");
					fx.service("PhotoSharingService").stop();
				}
				else if (this.model.creation.suspended && !Utils.getURLParam("connectionid") /*!this.model.connectionid*/)
				{
					this.switchTo("SuspendedBook");
					fx.service("PhotoSharingService").stop();
				}
				else
				{
					this.actionRequested = ""
					this.switchTo("BookEditor");
					fx.service("PhotoSharingService").start();
				}
				break;

			case "confirm-delete-photo":
				this.popup(new shared.popups.ConfirmDeletePhoto(e.data))
				break;

			case "cover-update-impossible" :
				this.popup(new common.popups.CoverUpdateImpossible(this.model, e.data))
				break;

			case "shape-album":
				this.switchTo("ShapeAlbum");
				break;
					
			/*case "select-cover":
				this._lastView = this.currentView;
				//this.switchTo("CoverAlbum", e.data);
				this.steps("CoverAlbum", "HardCover")
				break;

			case "cover-selection-finished":
				if (this._lastView)
					this.switchTo(this._lastView);
				break;*/

			/*case "cover-not-updated":
				this.model.event("show-editor");
			break;*/

			case "select-hard-cover":
				this.switchTo("HardCover");
				break;

			case "preview" :
				this.switchTo("Preview");
				break;

			case "creating-album":
				this.switchTo("CreatingAlbum");
				break;
			
			case "selectphotos" :
				this.switchTo("PhotoChoices", e.detail);
				break;

			/*case "photo-choice-back" :
				if (this.ia)
					this.switchTo("CoverAlbum");
				else
					this.switchTo("BookEditor");
				break;
			*/
			case "photos-files-selected":
				if (!this.ia)
					this.switchTo("BookEditor");
				break;
			
			case "magic-placement" :
				//if (this.model.iaEnabled)
					/*this.steps(	{view : "CreateAlbum", skipPrevious : true}, 
								{view : "PhotoAnalyse", skipPrevious : true}, 
								"PhotoList", 
								"TypeAlbum", 
								{view : "CreatingAlbum", skipPrevious : true}, 
								"BookEditor");*/
				//else
					//this.popup(new common.popups.MagicPlacement(this.model));
					//this.model.creator.createBook();
				break;

			case "photo-analyse":
				this.switchTo("PhotoAnalyse");
				break;

			case "import-mobile":
				this.popup(new shared.popups.EnterPhoneNumber(this.model));
				break;

            

			case "mobile-upload-photos":
				fx.service("SmsService").addPhotos(e.data);
				break;

			case "mobile-upload-started":
				if (fx.get("mode") ==  "creating-ia")
				{
					this.popup(null);
					this.model.event("step-PhotoListWaiting");
				}
				else
				{
					this.popup(null);
					this.switchTo("BookEditor");	
				}
				break;
			case "shared-photos-panel":
				this.switchTo("SharedPhotosPanel", this.model);
				break;
			case "mobile-upload-finished":
				if ( fx.get("mode") ==  "creating-ia" )
				{
					fx.service("AIService").processMobilePhoto( e.data );
					this.model.event("step-PhotoAnalyse");
				}
				break;
			case "mobile-upload-send":
				if ( (fx.get("mode") ==  "creating-ia") )
					this.model.event("step-PhotoListWaiting");
                else
                {
                    this.switchTo("BookEditor");
                    this.popup(new shared.popups.EnterPhoneSuccess(this.model));
                }
                    
				    
				break;
			case "order" :
				this.actionRequested = "";

				if (this.model.report().failed)	// Display warning popup only if there are reports on one/several page(s) or if number of pages is not a multiple of 4
					this.switchTo("CheckBookPanel");
				else
					this.model.event("propose-preview");
						
				break;

			case "check-creation-confirmed" :
				if (this.previewMode)
					this.model.event("order-confirmed");
				else
					this.model.event("propose-preview");
				break;

			case "order-confirmed" :

				if (this.readyLeaving(e.type))
					this.model.event("navigate-order", null, fx.service("PdfUploader").converting ? 250 : 0);

				break;

			case "exit-editor" :
				if (this.readyLeaving(e.type))
					this.model.event("navigate-exit", fx.service("PdfUploader").converting ? 250 : 0);
			
				break;

			case "propose-preview" :

				if (fx.get("mode") ==  "creating-ia" || this.ia)
					this.model.event("order-confirmed");
				else
				{
					//this.switchTo("ProposePreviewPanel");
                    this.steps({view : "ProposePreviewPanel", skipPrevious : true}, "Preview");
					//this.popup(new common.popups.ProposePreview(e.model, true /*this._preview*/));
					//this.model.event("preview");
				}
				break;
			
			/*case "change-theme-ai" :
				this.steps("ThemeCategories", 
								"ThemeAlbum", 
								"TypeAlbum", 
								"PreviewAI");
				break;*/

			case "upload-progress-closed":
				this.actionRequested = "";
			break;


			/***************** infoPanel / Soze / Cover *****************/
			case "size-album":
					this.switchTo( "SizeAlbum" );
				break;

			case "cover-album":
					this.steps("CoverAlbum", "HardCover");
				break;

			case "info-panel" :
					this._lastView = this.currentView;
					this.switchTo("InfoPanel")
				break;
                
			case "checkbook-panel" :
					this._lastView = this.currentView;
					this.switchTo("CheckBookPanel");
				break;

			case "change-thematics" :
				this.popup(new desktop.common.panels.ChangeThematicsPanel(this.model));
			break;
			
            case "change-themes" :
				this._lastView = this.currentView;
				this.switchTo("ChangeThemesPanel", e.data);
			break;
			
			case "size-selection-finished":
			case "cover-selection-finished" :
					this.switchTo("InfoPanel");
			break;

			case "info-panel-exit" :
				 	this.switchTo(this._lastView || "BookEditor")
			break;

			/***************** Import pictures *****************/

			case "import-facebook":
				this.popup(new desktop.common.photoimport.FacebookPanel(this.model));
				break;
			
			case "import-google":
				this.popup(new desktop.common.photoimport.GooglePanel(this.model));
				break;

			case "import-instagram":
				this.popup(new desktop.common.photoimport.InstagramPanel(this.model));
				break;

			case "import-albums":
				this.popup(new desktop.common.photoimport.AlbumsPhotos(this.model));
				break;

			case "album-photos-copied" :
			case "instagram-photos-added":
			case "facebook-photos-added":
			case "google-photos-added":
			case "local-photos-selected":

				if (this.currentView == "PhotoChoicesIA")
                {
                    if(e.detail.length < 20)
                        this.popup(new shared.popups.MessagePersonPopup(fx.text("Nombre de photos insuffisant"), fx.text("Veuillez sélectionner au minimum 24 photos.")));
                    else
                    {
                        fx.service("MediasUploader").photoExtractor.process(e.detail);
					    this.model.event("step-PhotoAnalyse");
                    }
                }
				else
					this.model.event("show-editor");

				break;
			

			case "upload-progress":
				if (this.currentPopup instanceof desktop.common.photoimport.UploadProgress)
					return;
				
				this.popup(new desktop.common.photoimport.UploadProgress(this.model));
				break;

			case "file-already-processing":
				this.popup(new shared.popups.FileAlreadyProcessing());
				break;

			case "file-uploaded":
				this.popup(new shared.popups.FileUploaded());
				break;	

			case "file-upload-failed":
			case "file-conversion-error":
				this.popup(new shared.popups.FileUploadFailed());
				break;

			/*case "file-conversion-finished":
				this.popup(new shared.popups.FileConversionFinished());
				break;*/

			case "file-uploading" :
				this.popup(new shared.popups.ConversionPdfFiles(e.model))
				break;

			case "files-not-uploaded":
				this.popup(new shared.popups.FileNotUploaded(e.data, this.model));
				break;

			case "failed-photos-canceled":
				if (this.currentView == "PhotoAnalyse")
					this.model.event("previous-step");
				break;

			case "cover-updated" :
				//if (fx.get("mode") == "edition")
					//this.popup(new common.popups.CoverChanged(fx.get("mode")));
				break;

			/*case "notice-select-files" : 
				this.popup(new shared.popups.NoticeSelectFiles(e.model))
				break;*/

			/*case "conversion-pdf-files" : 
				this.popup(new shared.popups.ConversionPdfFiles(e.model))
				break;*/

			

			/*case "ia-analyse" :
				this.popup(new shared.popups.IACreationPopup(this.model));
				break;*/

			


			/******************** Navigation ********************/
		


			default : 
				super.onDataEvent(e);
				break;
	
		}
	}

	_toggleGridMode(e)
	{
		fx.get("settings").toggleGridMode();
		
        e.stopPropagation();
		e.preventDefault();
	}

	





});